<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" :fill="outerColor" />
    <path
      d="M16.2527 10.8314L9.23122 7.18154C9.00192 7.06081 8.742 6.99818 8.4779 7.00004C8.2138 7.0019 7.95495 7.06818 7.72768 7.19213C7.50626 7.30881 7.3223 7.47741 7.19449 7.6808C7.06669 7.88419 6.99958 8.11513 7 8.35015V15.6499C6.99958 15.885 7.06669 16.1159 7.19449 16.3193C7.3223 16.5227 7.50626 16.6913 7.72768 16.808C7.95497 16.9319 8.21382 16.9981 8.4779 17C8.74199 17.0018 9.0019 16.9392 9.23122 16.8186L16.2527 13.1687C16.4791 13.0531 16.6679 12.8837 16.7993 12.6782C16.9307 12.4727 17 12.2386 17 12C17 11.7615 16.9307 11.5274 16.7993 11.3219C16.6679 11.1164 16.4791 10.947 16.2527 10.8314Z"
      :fill="innerColor"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 28,
      required: false,
    },
    outerColor: {
      type: String,
      default: '#000000',
      required: false,
    },
    innerColor: {
      type: String,
      default: '#ffffff',
      required: false,
    },
  },
};
</script>

<style scoped></style>
